var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "40px",
    viewBox: "0 0 49 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4CB4D24C-D341-42CE-9E1E-A9852086DE73") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup---Enabled",
    transform: "translate(-276.000000, -360.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner",
    transform: "translate(52.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner-Icon-Copy",
    transform: "translate(16.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.31,0.0001 C46.896,0.0001 49,2.0951 49,4.6701 L49,4.6701 L49,35.2931 C49,35.4971 48.972,35.6751 48.917,35.8461 C48.555,38.0301 46.61,39.6661 44.31,39.6661 L44.31,39.6661 L4.691,39.6661 C2.42,39.6661 0.479,38.0541 0.075,35.8321 C0.014,35.6731 -0.016,35.4201 0.009,35.1731 C0.002,35.1651 0,35.0811 0,34.9971 L0,4.6701 C0,2.0951 2.104,0.0001 4.691,0.0001 L4.691,0.0001 Z M18.737,23.7281 C18.23,23.1811 17.398,23.1411 16.842,23.6371 L16.842,23.6371 L3.53,35.7821 C3.788,36.1561 4.222,36.3921 4.691,36.3921 L4.691,36.3921 L44.31,36.3921 C44.785,36.3921 45.216,36.1601 45.473,35.7811 L45.473,35.7811 L36.346,26.4101 C35.792,25.8641 34.912,25.8621 34.349,26.4171 L34.349,26.4171 L29.834,31.0521 L31.102,32.4391 C31.743,32.9541 31.87,34.0001 31.33,34.7231 C31.061,35.0811 30.673,35.3091 30.236,35.3631 C29.8,35.4181 29.376,35.2931 29.033,35.0171 C28.89,34.9001 28.768,34.7621 28.671,34.6051 L28.671,34.6051 Z M44.31,3.2741 L4.691,3.2741 C3.916,3.2741 3.286,3.9001 3.286,4.6701 L3.286,4.6701 L3.285,31.5931 L14.698,21.2071 C15.591,20.3811 16.737,19.9521 17.945,20.0041 C19.149,20.0551 20.268,20.5821 21.097,21.4891 L21.097,21.4891 L27.581,28.5851 L32.009,24.0391 C33.888,22.2111 36.816,22.2121 38.684,24.0291 L38.684,24.0291 L45.715,31.2481 L45.715,4.6701 C45.715,3.9001 45.084,3.2741 44.31,3.2741 L44.31,3.2741 Z M30.5002,6.6665 C34.0842,6.6665 37.0002,9.5825 37.0002,13.1665 C37.0002,16.7505 34.0842,19.6665 30.5002,19.6665 C26.9162,19.6665 24.0002,16.7505 24.0002,13.1665 C24.0002,9.5825 26.9162,6.6665 30.5002,6.6665 Z M30.5002,9.9165 C28.7082,9.9165 27.2502,11.3745 27.2502,13.1665 C27.2502,14.9585 28.7082,16.4165 30.5002,16.4165 C32.2922,16.4165 33.7502,14.9585 33.7502,13.1665 C33.7502,11.3745 32.2922,9.9165 30.5002,9.9165 Z",
    id: "Combined-Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon);
export default __webpack_public_path__ + "static/media/banner-icon.d3946ee2.svg";
export { ForwardRef as ReactComponent };